import React from "react";
import { Option } from "../class/Option";

interface SelectProps {
  options: Option[];
  value: string;
  cssClass: string;
  onChange: (value: string) => void;
  children?: never[]; // 省略可能として定義
}

const Select: React.FC<SelectProps> = ({ options, value, cssClass, onChange }) => {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={`${cssClass}`}>
      <option value="">選択してください</option>
      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ))}
    </select>
  );
};

export default Select;